import transport from '../utils/axios';

// ==========================================
// Customer Notification Preferences (Backend Sprint 13)
//
// GET /me/notification-preferences
//   → { event: { email, sms, push } } matrix.
//
// PATCH /me/notification-preferences
//   → bulk update; backend applies the diff and returns the new matrix.
// ==========================================

export const getNotificationPreferences = () =>
    transport.get('/me/notification-preferences');

export const updateNotificationPreferences = (data) =>
    transport.patch('/me/notification-preferences', data);
